module.exports = __webpack_public_path__ + "assets/icons/star-o.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/star-o.svg
// module id = +Vwy
// module chunks = 1